module.exports = __webpack_public_path__ + "static/img/aGrape.3fd2601.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/aGrape.jpg
// module id = aH7j
// module chunks = 1